<ng-template appDynamicComponent></ng-template>
<router-outlet></router-outlet>
